import { PORTAL_ID } from './constants';

export function getHubspotFormApi(formId: string) {
  const hubspotFormApi = `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${formId}`;
  return hubspotFormApi;
}
